<template>
  <div>
    <v-dialog v-model="successDialog" max-width="600">
      <v-card>
        <v-card-title>Contact Added Successfully!</v-card-title>
        <v-card-text>
          <v-row align="center" justify="center">
            You have added a new contact to your database.
          </v-row>
          <div v-if="createdContact">
            <v-row align="center">
              <v-col cols="6">
                <div class="d-flex justify-center">
                  <v-avatar color="rgba(100, 154, 147, 1)" size="90">
                    <i
                      class="fi fi-rr-document"
                      style="color: #fff; z-index: 10"
                    ></i>
                  </v-avatar>
                </div>
                <p class="text-center">Preview</p>
              </v-col>
              <v-col cols="6">
                <p>
                  <span><b>First Name:</b></span
                  ><br />
                  {{ createdContact.firstName }}
                </p>
                <p>
                  <span><b>Last Name:</b></span
                  ><br />
                  {{ createdContact.lastName }}
                </p>
                <p>
                  <span><b>DOB:</b></span
                  ><br />
                  {{ createdContact.dob }}
                </p>
                <p>
                  <span><b>Tel No.:</b></span
                  ><br />
                  {{ createdContact.telNumber }}
                </p>
                <p>
                  <span><b>Cell No.:</b></span
                  ><br />
                  {{ createdContact.altNumber }}
                </p>
                <p>
                  <span><b>Email:</b></span> <br />
                  <a
                    :href="'mailto:' + createdContact.email"
                    style="font-weight: 700"
                    >{{ createdContact.email }}</a
                  >
                </p>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="center">
            <v-btn color="primary" class="my-4" @click="successDialog = false"
              >okay</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div style="max-height: 500px; overflow-y: auto">
      <v-form ref="ContactCreateForm" v-model="formValid">
        <v-row class="mx-1">
          <v-col cols="6">
            <p>First Name</p>
            <v-text-field
              v-model="contact.firstName"
              color="primary"
              outlined
              required
              :rules="[(v) => !!v || 'First name is required']"
            />
          </v-col>
          <v-col cols="6">
            <p>Surname</p>
            <v-text-field
              v-model="contact.lastName"
              color="primary"
              outlined
              required
              :rules="[(v) => !!v || 'Last name is required']"
            />
          </v-col>
          <v-col cols="6">
            <p>Email</p>
            <v-text-field
              v-model="contact.email"
              color="primary"
              outlined
              required
              :rules="[
                (v) => !!v || 'Email is required',
                (v) =>
                  /.+@.+\..+/.test(v) || 'Email Address format must be valid',
              ]"
            />
          </v-col>

          <v-col cols="6">
            <p>Subscribed</p>
            <v-switch label="Unsubscribed" v-model="contact.unsubscribe" />
          </v-col>
          <v-col cols="6">
            <p>Phone Number</p>
            <v-text-field
              v-model="contact.telNumber"
              prefix="(+27)"
              color="primary"
              outlined
              required
            />
          </v-col>
          <v-col cols="6">
            <p>Cell number</p>
            <v-text-field
              prefix="(+27)"
              placeholder="Please write"
              outlined
              v-model="contact.altNumber"
            />
          </v-col>
          <v-col cols="6">
            <p>International number</p>
            <v-text-field
              placeholder="Please write"
              outlined
              v-model="contact.intNumber"
            />
          </v-col>
          <v-col cols="6">
            <p>Role</p>
            <contact-role-picker
              :chosen-contact-role.sync="contact.contactRole"
              outlined
              :isCreate="true"
            />
          </v-col>
          <v-col cols="6">
            <p>Region</p>
            <region-picker
              :v-model="contact.region"
              :multiple="false"
              :chosen-region.sync="contact.region"
              :isCreate="true"
            />
          </v-col>
          <v-col cols="6">
            <p>LinkedIn Profile</p>
            <v-text-field
              placeholder="e.g. linkedin.com/in/johndoe"
              outlined
              v-model="contact.linkedInProfile"
            />
          </v-col>
          <v-col cols="6"
            ><p>Birthday</p>
            <date-of-birth-picker v-model="contact.dob"
          /></v-col>
          <v-col cols="6"
            ><p>Link to an HQ</p>
            <hq-name-picker
              :label="'HQ name'"
              :initial="hqID != '' ? hqID : contact.hqNames"
              :chosen-hq-name.sync="contact.hqNames"
              :newITEM="new_hq"
              outlined
              :many="true"
              :yesObject="false"
              :showCreate.sync="showHQcreate"
            />

            <hq-create
              v-if="showHQcreate"
              :hideDiag="true"
              :new_hq.sync="new_hq"
              :showCreate.sync="showHQcreate"
            />
          </v-col>
          <v-col cols="6"
            ><p>Religion</p>
            <religion-picker :chosen-religion.sync="contact.religion"
          /></v-col>
        </v-row>
      </v-form>
    </div>
    <div class="text-right">
      <v-btn
        :disabled="!formValid"
        color="primary"
        class="mx-2"
        @click="save()"
      >
        Save
      </v-btn>
      <v-btn color="primary" outlined @click="closeDialog()"> Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import ContactRolePicker from "@/components/Base/Pickers/ContactRolePicker.vue";
import RegionPicker from "@/components/Base/Pickers/RegionPicker.vue";
import ReligionPicker from "@/components/Base/Pickers/ReligionPicker.vue";
import HqNamePicker from "@/components/Base/Pickers/HqNamePicker.vue";
import DateOfBirthPicker from "@/components/Base/Pickers/DateOfBirthPicker.vue";

export default {
  name: "AddContact",
  components: {
    RegionPicker,
    ContactRolePicker,
    ReligionPicker,
    HqNamePicker,
    DateOfBirthPicker,
  },
  data() {
    return {
      isLoading: false,
      createdContact: null,
      successDialog: false,
      formValid: true,
      showHQcreate: false,
      hqID: [],
      me: null,
      new_hq: {},
      contact: {
        firstName: "",
        lastName: "",
        linkedInProfile: "",
        telNumber: "",
        email: "",
        contactRole: "",
        createdBy: "",
        dob: "",
        region: "",
        religion: "",
        unsubscribe: false,
        altNumber: "",
        hqNames: [],
        intNumber: "",
      },
      successMessage: "",
      errorMessage: "",
    };
  },
  apollo: {
    me: {
      query: gql`
        query {
          me {
            id
          }
        }
      `,
      update(data) {
        this.me = data.me;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      await this.saveContact();
      this.isLoading = false;
    },
    async saveContact() {
      const self = this;
      self.successMessage = "";
      self.errorMessage = "";
      if (self.$refs.ContactCreateForm.validate()) {
        try {
          const {
            firstName,
            lastName,
            linkedInProfile,
            telNumber,
            email,
            contactRole,
            region,
            religion,
            unsubscribe,
            dob,
            altNumber,
            intNumber,
            hqNames,
            createdBy,
          } = self.contact;
          const createdById = this.me ? this.me.id : null;
          //   const roleValue = Array.isArray(role) ? role[0] : role;
          const createdContact = await this.$apollo.mutate({
            mutation: gql`
              mutation ($contact: ContactCreateInput!) {
                createContact(contact: $contact) {
                  id
                  firstName
                  lastName
                  linkedInProfile
                  telNumber
                  email
                  contactRole
                  createdBy
                  region
                  religion
                  dob
                  altNumber
                  unsubscribe
                  intNumber
                }
              }
            `,
            variables: {
              contact: {
                firstName,
                lastName,
                linkedInProfile,
                telNumber,
                email,
                contactRole,
                createdBy: createdById,
                region,
                religion,
                dob,
                hqNames,
                altNumber,
                unsubscribe,
                intNumber,
              },
            },
            watchLoading(isLoading, countModifier) {
              this.isLoading = isLoading;
            },
          });
          if (createdContact) {
            this.createdContact = createdContact.data.createContact;
            self.successDialog = true;

            self.$emit("contactCreated");
          } else {
            console.error("Something went wrong when creating the contact!");
          }
        } catch (error) {
          self.errorMessage = `Contact Not Created / ${error.message}`;
          console.error(self.errorMessage);
          self.$swal(
            "Error!",
            `Something went wrong when creating the Contact, check data and try again later!`,
            "error"
          );
        }
      } else {
        self.errorMessage =
          "Contact Not Created/ All required fields must be completed.";
        console.error(self.errorMessage);
        self.$swal("Error!", "All required fields must be completed.", "error");
      }
    },

    async closeDialog() {
      this.$emit("close-add-contact-dialog", false);
      console.log("closeDialog initiated");
    },
  },
  watch: {
    new_hq(newValue) {
      newValue;
      this.hqID;

      if (newValue.value) {
        this.hqID = [this.hqID, newValue.value];
        this.contact.hqNames = [newValue.value];
      }
    },
  },
};
</script>
